import { render, staticRenderFns } from "./promotion-user-two.vue?vue&type=template&id=10290b58&scoped=true"
import script from "./promotion-user-two.vue?vue&type=script&lang=js"
export * from "./promotion-user-two.vue?vue&type=script&lang=js"
import style0 from "./promotion-user-two.vue?vue&type=style&index=0&id=10290b58&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10290b58",
  null
  
)

export default component.exports